import { RevEmptyPage, RevSpinner } from "@revmatics/catalyst";
import { useAppDispatch, useAppSelector } from "../../stores/hooks/hooks.ts";
import { useEffect } from "react";
import {
  fetchCampaignByIdData,
  fetchMediaPlanData,
} from "../../stores/thunks/campaignsThunk.tsx";
import { useParams } from "react-router";
import { MediaPlanPage } from "./MediaPlanPage.tsx";
import { fetchPersonasData } from "../../stores/thunks/personasThunk.tsx";
import {
  clearCampaignById,
  clearMediaPlan,
} from "../../stores/slice/campaignsSlice.tsx";
import campaignEmpty from "/images/empty_states/campaign-empty.svg";

export const MediaPlanWrapperPage = () => {
  const dispatch = useAppDispatch();
  const isLoadingMediaPlan = useAppSelector(
    (state) => state.campaigns.isLoadingMediaPlan,
  );
  const isLoadingById = useAppSelector(
    (state) => state.campaigns.isLoadingById,
  );
  const personas = useAppSelector((state) => state.personas.personas);
  const isLoadingList = useAppSelector((state) => state.personas.isLoadingList);
  const mediaPlanData = useAppSelector(
    (state) => state.campaigns.mediaPlanData,
  );
  const campaignById = useAppSelector((state) => state.campaigns.campaignById);
  const { campaignId } = useParams();
  useEffect(() => {
    if (!mediaPlanData && campaignId) {
      dispatch(fetchMediaPlanData({ id: Number(campaignId), params: {} }));
    }
    if (
      (!campaignById ||
        campaignById.id.toString() !== campaignId?.toString()) &&
      campaignId
    ) {
      dispatch(fetchCampaignByIdData(campaignId));
    }
  }, [dispatch, mediaPlanData, campaignId, campaignById]);

  useEffect(() => {
    return () => {
      dispatch(clearCampaignById());
      dispatch(clearMediaPlan());
    };
  }, [dispatch]);

  useEffect(() => {
    if (!personas) {
      dispatch(fetchPersonasData());
    }
  }, [dispatch, personas]);

  const isLoading = isLoadingList || isLoadingMediaPlan || isLoadingById;
  if (isLoading) {
    return (
      <div className="h-full">
        <RevSpinner size="large" centered color="primary" />
      </div>
    );
  }
  if (!isLoading && mediaPlanData && campaignById) {
    return (
      <MediaPlanPage
        mediaPlanData={mediaPlanData}
        campaignById={campaignById}
      />
    );
  }
  return (
    <RevEmptyPage
      image={campaignEmpty}
      title="Campaign Not Found"
      text="We couldn't find the campaign you were looking for."
      to="/campaigns"
      textBtn="Back to Campaigns"
    />
  );
};
